document.addEventListener("DOMContentLoaded", function(event) {
    
	//get all brands that have a gif attatched
	let elements = document.querySelectorAll('[data-gif]');

	//if we have some elements with a gif element
	if(elements) {

		let hover_enter = function(event) {
			//build ID for the target gif
			let gif = (event.target).querySelector('#' + event.target.id + '-gif');

			//if we have a target
			if(gif) {

				//set the src
				gif.src = event.target.dataset.gif;
			}

			event.target.classList.add('gif');
		}

		let hover_exit = function(event) {
			event.target.classList.remove('gif');
		}

		//loop over them
		for(let i = 0; i < elements.length; i++) {
			elements[i].addEventListener('mouseenter', hover_enter);
			elements[i].addEventListener('mouseleave', hover_exit);
		}
	}
});